import 'pixi.js';
import {injectable} from 'inversify';
import {BasicView} from '@fantasmagames/slot/src/common/view/BasicView';

export enum ViewTypes {
	DESKTOP,
	LANDSCAPE,
	PORTRAIT,
}

/**
 * abstract class every view must be extended from. also has possibility to send events within the module
 * usually events are needed to module further consideration of actions
 */
@injectable()
export abstract class View extends BasicView {
	protected _landscapeView: View;
	protected _portraitView: View;
	protected _views: View[] = [];

	protected _parentView: View;

	protected _viewType: ViewTypes = 0;

	private _hasFewMobileViews: boolean = false;

	public setupViewType(viewType: ViewTypes): void {
		this._viewType = viewType;
	}

	public setupParentView(view: View): void {
		this._parentView = view;
	}

	public addStandardMobileViews(viewIdentifier: string): void {
		if (this._views && this._views.length > 0) {
			throw new Error('View::addStandardMobileViews this view already has views created');
		}

		const landscapeView: View = this._system.container.get(viewIdentifier);
		landscapeView.setupViewType(ViewTypes.LANDSCAPE);
		landscapeView.setupParentView(this);

		const portraitView: View = this._system.container.get(viewIdentifier);
		portraitView.setupViewType(ViewTypes.PORTRAIT);
		portraitView.setupParentView(this);

		this._landscapeView = landscapeView;
		this._portraitView = portraitView;
		this._views.push(this._landscapeView);
		this._views.push(this._portraitView);

		this._hasFewMobileViews = true;
	}

	public addMobileViews(landscapeView: View, portraitView: View): void {
		this._landscapeView = landscapeView;
		this._portraitView = portraitView;

		this._views.push(this._landscapeView);
		this._views.push(this._portraitView);

		this._hasFewMobileViews = true;
	}

	public show(): void {
		if (this.hasFewMobileViews) {
			this._views.map((view: View) => {
				view.show();
			});
		} else {
			super.show();
		}
	}

	public hide(): void {
		if (this.hasFewMobileViews) {
			this._views.map((view: View) => {
				view.hide();
			});
		} else {
			super.hide();
		}
	}

	public on(id: string, callback: Function, owner: Object, priority: number = 0, data: any = null): void {
		if (this.hasFewMobileViews) {
			this._views.map((view: View) => {
				view.on(id, callback, owner, priority, data);
			});
		} else {
			super.on(id, callback, owner, priority, data);
		}
	}

	public off(id: string, owner: Object): void {
		if (this.hasFewMobileViews) {
			this._views.map((view: View) => {
				view.off(id, owner);
			});
		} else {
			super.off(id, owner);
		}
	}

	public emit(id: string, ...args: any[]): void {
		if (this._hasFewMobileViews) {
			this._views.map((view: View) => {
				view.emit(id, ...args);
			});
		} else {
			super.emit(id, ...args);
		}
	}

	public onLandscape(): void {
		if (this.hasFewMobileViews) {
			this._portraitView.hideContainer();
			this._landscapeView.showContainer();
		}
	}

	public onPortrait(): void {
		if (this.hasFewMobileViews) {
			this._landscapeView.hideContainer();
			this._portraitView.showContainer();
		}
	}

	public viewCallback(callback: Function, functionName: string, ...argArray: any[]): Function {
		if (this._parentView) {
			return () => {
				if (this._parentView.landscapeView[functionName]) {
					this._parentView.landscapeView[functionName](...argArray);
				} else {
					throw new Error(`function ${functionName} does not exist in landscape view ${this.constructor.name}`);
				}

				if (this._parentView.portraitView[functionName]) {
					this._parentView.portraitView[functionName](...argArray);
				} else {
					throw new Error(`function ${functionName} does not exist in portrait view ${this.constructor.name}`);
				}
			};
		} else {
			return () => {
				callback(argArray);
			};
		}
	}

	public get hasFewMobileViews(): boolean {
		return this._hasFewMobileViews;
	}

	public get viewType(): ViewTypes {
		return this._viewType;
	}

	public get landscapeView(): View {
		return this._landscapeView;
	}

	public get portraitView(): View {
		return this._portraitView;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/common/view/View.ts